(function($) {
  $( document ).ready(function() {
    togglePeople()
    showparking()

    $('.main-navigation a').focus(function () {
      var that = $(this);

      setTimeout(function () {
        that.parents('li').addClass('sfHover')
      }, 400)
    })

    $('.main-navigation a').focusout(function () {
      var that1 = $(this);

      setTimeout(function () {
        that1.parents('li').removeClass('sfHover')
      }, 401)
    })

  })

  $( document ).ajaxComplete(function() {
    togglePeople()
    showparking()
  });

})( jQuery );

function togglePeople() {
  jQuery('.open-data').each( function() {
    jQuery(this).on("click", function(e){
      e.preventDefault()
      var idData = $(this).data('id');

      jQuery(this).parent().toggleClass('active');
      jQuery(this).parent().find('.table-toggle').toggleClass('active');

      jQuery('#'+idData).toggleClass('active')

      if (jQuery('#'+idData).hasClass('active')) {
        jQuery('#'+idData).removeClass('hide')
      } else {
        jQuery('#'+idData).addClass('hide')
      }
    });
  })
}

function showparking() {
  jQuery('body').addClass('maps--fixScroll');

  jQuery('.map-link').each( function() {
    jQuery(this).on("click", function(e){
      e.preventDefault()

      var gpsData = $(this).data('gps');

      if (gpsData) {
        window.map.setCenterZoom(parseGps(gpsData), 15, true)

        if ( jQuery('#parkovisteMap').length) {
          moveScreenToMap('#parkovisteMap')
        }
        if (jQuery('#vystarhyMap').length) {
          moveScreenToMap('#vystarhyMap')
        }
      }

    });
  })
}

function parseGps(data) {
  return SMap.Coords.fromWGS84(data)
}

function moveScreenToMap(mapSelector) {

  jQuery('html, body').animate({
    scrollTop: jQuery(mapSelector).offset().top - 100
  }, 800, function(){
    window.location.hash = mapSelector
    ;
  });
}
